import { render } from "./SelectedElementsCollection.vue?vue&type=template&id=07256aa0&scoped=true"
import script from "./SelectedElementsCollection.vue?vue&type=script&lang=js"
export * from "./SelectedElementsCollection.vue?vue&type=script&lang=js"

import "./SelectedElementsCollection.vue?vue&type=style&index=0&id=07256aa0&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07256aa0"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
